import _ from 'lodash';

export function expandArr(val) {
  // lodash 将多维数组展开为一维数组
  const arr = _.flattenDeep(val);
  // lodash 删除数组中的空元素
  return _.remove(arr, item => !_.isEmpty(item));
}
